import { useContext } from "react"
import { TelefoneBloqueadosContext } from "./TelefoneBloqueadosContext"

export function useTelefoneBloqueadosContext() {
    return useContext(TelefoneBloqueadosContext)
}
